import { useRef, useEffect, useState } from 'react';

const marqueeCardsA = [
  {
    type: 'image' as const,
    src: 'https://readdy.ai/api/search-image?query=Group%20of%20young%20content%20creators%20at%20creator%20convention%20event%2C%20casual%20confident%20poses%20in%20front%20of%20branded%20step%20and%20repeat%20backdrop%2C%20warm%20event%20lighting%2C%20candid%20group%20photography%20style%2C%20energetic%20atmosphere%2C%20modern%20event%20photography%2C%20diverse%20group%20of%20influencers%2C%20vertical%20portrait%20crop&width=520&height=680&seq=fanfix-event-1&orientation=portrait',
    alt: 'Creators at event',
    rotate: -4,
    offsetY: 10,
    overlap: -22,
    zBase: 5,
  },
  {
    type: 'image' as const,
    src: 'https://static.readdy.ai/image/3b456c85121e0a57a712c6782e681ea6/79cbde9a36344264a55825f791f2f94d.png',
    alt: 'Creator outdoors',
    rotate: 3,
    offsetY: -14,
    overlap: -26,
    zBase: 8,
  },
  {
    type: 'stat' as const,
    value: 'Earn 92% of all Money Earned on Smugg.me',
    label: 'Paid out to creators',
    bg: '#f0abfc',
    textColor: '#1f2937',
    lineColor: 'rgba(0,0,0,0.18)',
    rotate: -7,
    offsetY: 8,
    overlap: -18,
    zBase: 6,
  },
  {
    type: 'image' as const,
    src: 'https://storage.readdy-site.link/project_files/f4f0a068-4d6e-4d8b-b9c5-f019c11b8e5c/9d478c41-d214-4d39-9981-1e579d4b1f60_compressed_WhatsApp-Image-2026-07-21-at-13.58.00.webp',
    alt: 'Fitness creator workout',
    rotate: 5,
    offsetY: -10,
    overlap: -24,
    zBase: 9,
  },
  {
    type: 'image' as const,
    src: 'https://static.readdy.ai/image/3b456c85121e0a57a712c6782e681ea6/38951bf8181248b34aeb6699cd23759f.png',
    alt: 'Creator in cap',
    rotate: -2,
    offsetY: 16,
    overlap: -20,
    zBase: 4,
  },
  {
    type: 'stat' as const,
    value: 'Grow your Community on Smugg.me',
    label: 'Fans on Smugg.me',
    bg: '#f87171',
    textColor: '#ffffff',
    lineColor: 'rgba(255,255,255,0.35)',
    rotate: 6,
    offsetY: -8,
    overlap: -16,
    zBase: 7,
  },
  {
    type: 'image' as const,
    src: 'https://static.readdy.ai/image/3b456c85121e0a57a712c6782e681ea6/3116814fee77f71fd3d3c0c53bc0f761.png',
    alt: 'Female creators group',
    rotate: -6,
    offsetY: 12,
    overlap: -28,
    zBase: 10,
  },
  {
    type: 'image' as const,
    src: 'https://static.readdy.ai/image/3b456c85121e0a57a712c6782e681ea6/e1537e99ba3d2c0e266550bae959adc7.png',
    alt: 'Creator in cowboy hat',
    rotate: 4,
    offsetY: -16,
    overlap: -14,
    zBase: 3,
  },
  {
    type: 'stat' as const,
    value: 'Earn on your on time , just share the Smuggme',
    label: 'Smugg.me millionaires',
    bg: '#d9f99d',
    textColor: '#1f2937',
    lineColor: 'rgba(0,0,0,0.18)',
    rotate: -3,
    offsetY: 6,
    overlap: -20,
    zBase: 5,
  },
];

function MarqueeCard({
  item,
  index,
}: {
  item: (typeof marqueeCardsA)[0];
  index: number;
}) {
  const [hovered, setHovered] = useState(false);

  const baseTransform = `rotate(${item.rotate}deg) translateY(${item.offsetY}px)`;
  const hoverTransform = `rotate(0deg) translateY(${item.offsetY - 32}px) scale(1.05)`;

  if (item.type === 'image') {
    return (
      <div
        className="flex-shrink-0 rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: 'clamp(180px, 18vw, 260px)',
          aspectRatio: '13/16',
          marginLeft: index === 0 ? 0 : `${item.overlap}px`,
          transform: hovered ? hoverTransform : baseTransform,
          boxShadow: hovered
            ? '0 28px 56px rgba(0,0,0,0.22), 0 0 0 3px rgba(168,85,247,0.20)'
            : '0 6px 16px rgba(0,0,0,0.08)',
          zIndex: hovered ? 100 : item.zBase + (index % 20),
          transition:
            'transform 0.4s cubic-bezier(0.34,1.6,0.64,1), box-shadow 0.35s ease',
        }}
      >
        <img
          src={item.src}
          alt={item.alt}
          className="w-full h-full object-cover object-top"
          loading="lazy"
          draggable={false}
        />
      </div>
    );
  }

  return (
    <div
      className="flex-shrink-0 rounded-2xl p-4 sm:p-5 flex flex-col justify-between transition-all duration-300 cursor-pointer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: 'clamp(180px, 18vw, 260px)',
        aspectRatio: '13/16',
        marginLeft: `${item.overlap}px`,
        background: item.bg,
        transform: hovered ? hoverTransform : baseTransform,
        boxShadow: hovered
          ? '0 28px 56px rgba(0,0,0,0.22), 0 0 0 3px rgba(168,85,247,0.20)'
          : '0 6px 16px rgba(0,0,0,0.10)',
        zIndex: hovered ? 100 : item.zBase + (index % 20),
        transition:
          'transform 0.4s cubic-bezier(0.34,1.6,0.64,1), box-shadow 0.35s ease',
      }}
    >
      <div
        className="text-3xl sm:text-4xl font-black leading-none"
        style={{
          color: item.textColor,
          fontFamily: "'Calibri', 'Segoe UI', 'Candara', 'Arial', sans-serif",
        }}
      >
        {item.value}
      </div>
      <div>
        <div
          className="w-10 h-px mb-3"
          style={{ background: item.lineColor || 'rgba(255,255,255,0.3)' }}
        />
        <p
          className="text-sm font-semibold leading-snug"
          style={{ color: item.textColor }}
        >
          {item.label}
        </p>
      </div>
    </div>
  );
}

export default function FanfixHero() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const trackA = [...marqueeCardsA, ...marqueeCardsA];

  return (
    <section
      ref={sectionRef}
      className="relative w-full overflow-hidden bg-[#faf8f5] dark:bg-gray-900"
    >
      {/* ── Title area ── */}
      <div className="max-w-7xl mx-auto px-6 pt-14 sm:pt-20 pb-4">
        <div
          className="text-center mb-2"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(16px)',
            transition: 'opacity 0.6s ease, transform 0.6s ease',
          }}
        >
          <p className="text-xs sm:text-sm font-black uppercase tracking-[0.2em] text-gray-800 dark:text-gray-100">
            A Multiverse Social Platform for you the
          </p>
        </div>

        <div
          className="flex flex-col items-center mb-4"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
            transition: 'opacity 0.7s ease 0.15s, transform 0.7s ease 0.15s',
          }}
        >
          <h2
            className="font-black uppercase text-gray-900 dark:text-white leading-[0.82] select-none"
            style={{
              fontSize: 'clamp(3rem, 12vw, 8rem)',
              letterSpacing: '-0.04em',
              fontFamily: "'Calibri', 'Segoe UI', 'Candara', 'Arial', sans-serif",
            }}
          >
            
          </h2>
          <span
            className="font-bold -mt-4 sm:-mt-6 md:-mt-8 lg:-mt-10 select-none bg-clip-text text-transparent mx-auto block text-center"
            style={{
              fontFamily: "'Dancing Script', cursive",
              fontSize: 'clamp(3.2rem, 10.5vw, 7.5rem)',
              lineHeight: 1.05,
              backgroundImage: 'linear-gradient(90deg, #4f8ef7 0%, #8b5cf6 50%, #ec4899 100%)',
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.92)',
              transition: 'opacity 0.8s ease 0.25s, transform 0.8s cubic-bezier(0.34, 1.6, 0.64, 1) 0.25s',
            }}
          >
            Creators
          </span>
        </div>

        <div
          className="text-center max-w-2xl mx-auto mb-6 sm:mb-8"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(16px)',
            transition: 'opacity 0.6s ease 0.3s, transform 0.6s ease 0.3s',
          }}
        >
          <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300 leading-relaxed">
            Smugg.me enables creators &amp; up-coming creators to offer exclusive content, grow recurring revenue, and
            strengthens relationships with fans, all in a brand-safe environment.
          </p>
        </div>
      </div>

      {/* ── Marquee area ── */}
      <div className="relative w-full pb-8 sm:pb-12">
        {/* Left fade edge */}
        <div
          className="absolute left-0 top-0 bottom-0 w-28 sm:w-40 z-20 pointer-events-none bg-gradient-to-r from-[#faf8f5] to-transparent dark:from-gray-900"
        />
        {/* Right fade edge */}
        <div
          className="absolute right-0 top-0 bottom-0 w-28 sm:w-40 z-20 pointer-events-none bg-gradient-to-l from-[#faf8f5] to-transparent dark:from-gray-900"
        />

        {/* Single marquee row */}
        <div className="flex animate-marquee items-center py-1">
          {trackA.map((item, index) => (
            <MarqueeCard key={`a-${item.type}-${index}`} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}